/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advanced_Maintenance_GatewaysInputs */



/**
* | output |
* | --- |
* | "Box" |
*
* @param {Advanced_Maintenance_GatewaysInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const advanced_maintenance_gateways = /** @type {((inputs?: Advanced_Maintenance_GatewaysInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advanced_Maintenance_GatewaysInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Box")
	return /** @type {LocalizedString} */ ("Box")
});